<template>
<div>
<p>
The Wyvern DAO is a distributed autonomous organization, running on the Ethereum blockchain, responsible for governance of the Wyvern Exchange protocol and development of the present instantiation at <a href="https://exchange.projectwyvern.com" target="_blank">exchange.projectwyvern.com</a>.
</p>
<p>
This web application provides an interface to the DAO smart contract, allowing DAO shareholders to create new proposals, view past proposals, vote yea or nay on active proposals, manage vote delegation, and analyze the DAO's current asset holdings.
</p>
<p>
Anyone in possession of <a href="https://token.projectwyvern.com" target="_blank">WYV tokens</a> is a shareholder in the Wyvern DAO, with voting rights proportional to their token holdings. To exercise your rights, you must connect to this DApp with the account holding your tokens - to do so, set the appropriate network options by clicking "Network Configuration" at the top right.
</p>
<p>
All application code is open-source. To request a fix or suggest an improvement, please open an issue or submit a pull request using the <a href="https://github.com/ProjectWyvern/dao.projectwyvern.com">Github repository</a>.
</p>
<p>
To learn more about the Wyvern project, visit <a href="https://projectwyvern.com" target="_blank">projectwyvern.com</a>. You can also follow us on <a href="https://twitter.com/WyvernProtocol" target="_blank">Twitter</a> or <a href="https://medium.com/project-wyvern" target="_blank">Medium</a>. For realtime support, join our <a href="https://riot.im/app/#/room/#projectwyvern:matrix.org">Matrix chat (via Riot)</a>.
</p>
</div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Help'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Help.vue